import PropTypes from 'prop-types'

export default PropTypes.shape({
  custom: PropTypes.bool.isRequired,
  description: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  editable: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  multiValued: PropTypes.bool.isRequired,
  required: PropTypes.bool.isRequired,
  scimAttributeName: PropTypes.string.isRequired,
  scimSchema: PropTypes.string.isRequired,
  targetable: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['complex', 'binary', 'boolean', 'datetime', 'decimal', 'integer', 'string']).isRequired,
  visible: PropTypes.bool.isRequired
})
